import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-back-link',
  templateUrl: './back-link.component.html',
  styleUrls: ['./back-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackLinkComponent {
  @Input() link: string | any[];
}
